<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewUsers' }" class="mb-0 main-identifier fw-semibold text-decoration-none"
        title="Go back to Users">
        Users
      </router-link>
      <span class="material-symbols-outlined">arrow_right</span>
      <p class="mb-0 sub-identifier">Edit User</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="submitForm">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Edit User</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="first_name">Username</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="currentUserName"
                        id="first_name" placeholder="" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label
                        for="first_name">Role</label></div>
                    <div class="col-md-10 input-right">
                      <select class="form-select form-view-only-input" v-model="currentRoleId" @change="onRoleChange"
                        placeholder="" required>
                        <option value="" disabled> - Select Role - </option>
                        <option v-for="r in roles" :key="r.id" :value="r.id">
                          {{ r.description }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group" id="group_select"
                    v-if="showGroupSelect">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="first_name">Group</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <select class="form-select form-view-only-input" v-model="currentGroupId" required>
                        <option value="" disabled> - Select Group - </option>
                        <option v-for="g in groups" :key="g.id" :value="g.id">
                          {{ g.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="first_name">First Name</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <input type="text" class="form-control" :value="newFirstName"
                        :placeholder="currentFirstName !== null ? currentFirstName : ''" required id="first_name">
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="last_name">Last Name</label>
                    </div>
                    <div class="col-md-10 input-right">
                      <input type="text" class="form-control" :value="newLastName"
                        :placeholder="currentLastName !== null ? currentLastName : ''" id="last_name" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                      <label for="email">Email</label>
                    </div>
                    <!-- <div class="col-md-10 input-right"><input type="email" class="form-control" v-model="newEmail"
                        :placeholder="currentEmail !== null ? currentEmail : ''" id="email" required></div> -->
                    <div class="col-md-10 input-right">
                      <input type="email" class="form-control form-view-only-input" v-model="currentEmail"
                        placeholder="" id="email" readonly required>
                    </div>
                  </div>

                </div>

                <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading || !currentFirstName">
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<!-- <script setup>
import { defineOptions } from 'vue'
import DashboardLayout from '../layout/DashboardLayout.vue'

defineOptions({
  name: 'CreateUserPage',
})
</script> -->

<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2';

const roles = ref([])
const groups = ref([])

const currentUserName = ref('')
const currentRoleId = ref('')
const currentGroupId = ref('')
const currentFirstName = ref('')
const currentLastName = ref('')
const currentEmail = ref('')
const form = reactive({
  userName: '',
  firstName: '',
  lastName: '',
  roleId: '',
  groupTypeId: '',
  email: '',
  id: '',
  appraisalRemark: '',
  changePassword: false,
  commissioner: false,
  createdDate: '',
  deltaPasswordInd: '',
  dirOfBudget: false,
  groupHead: false,
  lastLoginDate: '',
  lastModifiedDate: '',
  password: '',
  permSec: false,
  roleName: '',
  timeLoggedIn: '',
  userSign: ''
})

const newUserName = ref('')
const newRole = ref('')
const newGroup = ref('')
const newFirstName = ref('')
const newLastName = ref('')
const newEmail = ref('')

const root_api_url = process.env.VUE_APP_API_ROOT_URL;
const route = useRoute()
const id = route.params.id
const isLoading = ref(false)

const initialForm = JSON.parse(JSON.stringify(form));

function resetAll() {
  // restore form fields
  Object.assign(form, JSON.parse(JSON.stringify(initialForm)));
}

const fetchUser = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/auth/user/client/id/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    const userData = response.data;
    currentUserName.value = userData.userName || '';
    currentRoleId.value = userData.roleId ?? '';
    currentGroupId.value = userData.groupTypeId ?? '';
    currentFirstName.value = userData.firstName;
    currentLastName.value = userData.lastName;
    currentEmail.value = userData.email;
    form.id = userData.id;
    form.appraisalRemark = userData.appraisalRemark || '';
    form.changePassword = userData.changePassword || '';
    form.commissioner = userData.commissioner;
    form.createdDate = userData.createdDate || '';
    form.deltaPasswordInd = userData.deltaPasswordInd || '';
    form.dirOfBudget = userData.dirOfBudget;
    form.groupHead = userData.groupHead;
    form.lastLoginDate = userData.lastLoginDate || '';
    form.lastModifiedDate = userData.lastModifiedDate || '';
    form.password = userData.password || '';
    form.permSec = userData.permSec;
    form.roleName = userData.roleName || '';
    form.timeLoggedIn = userData.timeLoggedIn || '';
    form.userSign = userData.userSign || '';

    // Clear new values (placeholder approach)
    newUserName.value = ''
    newRole.value = ''
    newGroup.value = ''
    newFirstName.value = ''
    newLastName.value = ''
    newEmail.value = ''

    console.log("User Data:", userData);
  } catch (error) {
    console.error('Failed to fetch user:', error)
  }
}

const fetchRoles = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/auth/role`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    //roles.value = response.data

    roles.value = response.data.map(role => ({
      id: role.id,
      name: role.roleName,
      description: role.description
    }))

    // console.log(roles.value)
  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const fetchGroupTypes = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/group-type`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    //roles.value = response.data

    groups.value = response.data.map(group => ({
      id: group.id,
      name: group.name,
      groupHeadId: group.groupHeadId
    }))

    // console.log("Groups: ", groups.value)
  } catch (error) {
    console.error('Failed to fetch groups:', error)
  }
}

const selectedRole = computed(() => roles.value.find(r => r.id === currentRoleId.value))
// const currentRole = computed(() => roles.value.find(r => r.id === currentRoleId.value))

// const showCurrentGroup = computed(() =>
//   selectedRole.value && selectedRole.value.description.toLowerCase().includes('group')
// )

const showGroupSelect = computed(() =>
  selectedRole.value && selectedRole.value.description.toLowerCase().includes('group')
)

const onRoleChange = async () => {
  if (showGroupSelect.value) {
    await fetchGroupTypes()
  } else {
    groups.value = []
    currentGroupId.value = ''
  }
}

const submitForm = async () => {
  isLoading.value = true
  const token = Cookies.get('auth_token');

  const firstName = newFirstName.value.trim() !== '' ? newFirstName.value : currentFirstName.value;
  const lastName = newLastName.value.trim() !== '' ? newLastName.value : currentLastName.value;

  const userData = {
    ...form,
    userName: currentUserName.value,
    firstName,
    lastName,
    roleId: currentRoleId.value,
    groupTypeId: currentGroupId.value,
    email: currentEmail.value,
  };

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  console.log("Submitting user data:", userData);
  try {
    await axios.put(`${root_api_url}/auth/user/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    console.log('User edited successfully', userData);

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>User edited successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });

    newFirstName.value = currentFirstName.value || ''
    newLastName.value = currentLastName.value || ''

    resetAll();
    await fetchUser()
    isLoading.value = false;

  } catch (error) {
    Swal.fire({
      html: `${iconHtmlError}
       <h1 style="font-weight:600;">Error</h1>
       <p>An error occurred while editing the user.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchUser(),
    fetchRoles(),
    fetchGroupTypes(),
    document.title = "Edit User"
})

</script>

<style scoped>
.custom-select option {
  font-size: 18px;
  background-color: #fff;
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
}
</style>
